import { produtosApi, CATEGORY_TREE_ENDPOINT } from "../../../../../page/OrderResumePag/_services/api";

function flattenCategories(tree = []) {
  return tree.reduce((acc, category) => {
    acc.push(category);
    if (Array.isArray(category.children) && category.children.length > 0) {
      acc.push(...flattenCategories(category.children));
    }
    return acc;
  }, []);
}

export async function getCategories() {
  const response = await produtosApi.get(CATEGORY_TREE_ENDPOINT);
  return response.data?.data ?? [];
}

export async function getCategory(uuid) {
  const categories = await getCategories();

  const findRecursive = (list = []) => {
    for (const item of list) {
      if (item.uuid === uuid) {
        return item;
      }
      if (item.children?.length) {
        const found = findRecursive(item.children);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  return findRecursive(categories);
}

export function getFlattenedCategories(tree) {
  return flattenCategories(tree);
}
